import type { FC } from "react";
import { defaultColor } from "../constants";
import type { IconProps } from "./types";
export const Extension: FC<IconProps> = ({
  color = defaultColor,
  height = 24,
}) => (
  <svg
    width="25"
    height={height}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_1634_6858"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="25"
      height="24"
    >
      <rect x="0.5" width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1634_6858)">
      <path
        d="M5.6 10.95C5.0225 10.95 4.52813 10.7444 4.11688 10.3331C3.70563 9.92188 3.5 9.4275 3.5 8.85V5.1C3.5 4.5225 3.70563 4.02813 4.11688 3.61688C4.52813 3.20563 5.0225 3 5.6 3H9.35C9.9275 3 10.4219 3.20563 10.8331 3.61688C11.2444 4.02813 11.45 4.5225 11.45 5.1V8.85C11.45 9.4275 11.2444 9.92188 10.8331 10.3331C10.4219 10.7444 9.9275 10.95 9.35 10.95H5.6ZM5.6 21C5.0225 21 4.52813 20.7944 4.11688 20.3831C3.70563 19.9719 3.5 19.4775 3.5 18.9V15.15C3.5 14.5725 3.70563 14.0781 4.11688 13.6669C4.52813 13.2556 5.0225 13.05 5.6 13.05H9.35C9.9275 13.05 10.4219 13.2556 10.8331 13.6669C11.2444 14.0781 11.45 14.5725 11.45 15.15V18.9C11.45 19.4775 11.2444 19.9719 10.8331 20.3831C10.4219 20.7944 9.9275 21 9.35 21H5.6ZM15.65 10.95C15.0725 10.95 14.5781 10.7444 14.1669 10.3331C13.7556 9.92188 13.55 9.4275 13.55 8.85V5.1C13.55 4.5225 13.7556 4.02813 14.1669 3.61688C14.5781 3.20563 15.0725 3 15.65 3H19.4C19.9775 3 20.4719 3.20563 20.8831 3.61688C21.2944 4.02813 21.5 4.5225 21.5 5.1V8.85C21.5 9.4275 21.2944 9.92188 20.8831 10.3331C20.4719 10.7444 19.9775 10.95 19.4 10.95H15.65ZM15.65 21C15.0725 21 14.5781 20.7944 14.1669 20.3831C13.7556 19.9719 13.55 19.4775 13.55 18.9V15.15C13.55 14.5725 13.7556 14.0781 14.1669 13.6669C14.5781 13.2556 15.0725 13.05 15.65 13.05H19.4C19.9775 13.05 20.4719 13.2556 20.8831 13.6669C21.2944 14.0781 21.5 14.5725 21.5 15.15V18.9C21.5 19.4775 21.2944 19.9719 20.8831 20.3831C20.4719 20.7944 19.9775 21 19.4 21H15.65Z"
        fill={color}
      />
    </g>
  </svg>
);
